import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import ActionGroupsTable from './ActionGroupsTable';
import { getAllGroupsInitiate } from '../../../../actions/groups';
import { getEmployeeSectionDataInitiate } from '../../../../actions/employee';
import { currentFlowTypeEnum } from '../../../common/components/constants';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    selectedWorkspace,
  };
};

const mapDispatchToProps = dispatch => ({
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
  getEmployeeSection: payload =>
    dispatch(getEmployeeSectionDataInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActionGroupsTable);
